/* Termos comuns utilizados em todo o sistema */
export const CommonTranslations = {
  BUTTON_CANCEL: 'btn_cancel',
  BUTTON_DELETE: 'btn_delete',
  BUTTON_NEW: 'btn_new',
  BUTTON_SAVE: 'btn_save',
  CHECKBOX_ATIVO: 'chk_ativo',
  CHECKBOX_INATIVO: 'chk_inativo',

  // labels padrões
  LABEL_PASSWORD: 'lbl_password',
  LABEL_PDV: 'lbl_pdv',
  LABEL_USER: 'lbl_user',

  // itens de menu do módulo Front
  MENU_ITEM_CADASTRO: 'menuitem_cadastro',
  MENU_ITEM_CATEGORIASERVICOS: 'menuitem_categoriasservicos',
  MENU_ITEM_CLIENTE: 'menuitem_cliente',
  MENU_ITEM_MOTIVOCANCELAMENTO: 'menuitem_motivocancelamento',
  MENU_ITEM_ORDEMSERVICO: 'menuitem_ordemservico',
  MENU_ITEM_SERVICOS: 'menuitem_servicos',
  MENU_ITEM_VENDEDORES: 'menuitem_vendedores',

  // itens dos menus gerais
  MENU_ITEM_SAIR: 'menuitem_sair',

  // itens das abas gerais
  TABSHEET_GERAL: 'tabsheet_geral',

  // colunas de grids
  GRID_COLUMN_ACOES: 'gridcolumn_acoes'
};

/* Chaves de tradução dos labels do dashboard do módulo Front */
export const Dashboard_Front_Translations = {
  LABEL_CHEGADAS: 'lbl_dash_front_chegadas',
  LABEL_PARTIDAS: 'lbl_dash_front_partidas',
  LABEL_PAX_DESTINO: 'lbl_dash_front_paxdestino'
};

/* Chaves de tradução do formulário de OS */
export const Form_OS_Translations = {
  FORM_TITLE: 'form_OS_title_form'
};

/* Chaves de tradução do formulário de categoria de serviço */
export const Form_CategoriaServico_Translations = {
  FORM_TITLE: 'form_categoriaservico_title_form'
};

/* Chaves de tradução da listagem de categoria de serviço */
export const list_CategoriaServico_Translations = {
  LIST_TITLE: 'form_categoriaservico_grid_column'
};